import React, { useState } from "react";
import "../Assets/Css/ResetPassword.css";
import resetSuccessful from "../Assets/Json/successLottie.json";
import Lottie from "react-lottie";
import { POST_DELETE_API } from "../Component/AllApi";
import hideIcon from "../Assets/Images/Dashboard/hide.png";
import showIcon from "../Assets/Images/Dashboard/show.png";
import logo from "../Assets/Images/Dashboard/reset-password-logo.png";
const DeleteTeacher = () => {
  const [inputData, setInputData] = useState({
    new_pass: ""
  });
  const [inputError, setInputError] = useState({});
  const [showSuccessfullReset, setShowSuccessfullReset] = useState(false);

  const [newPassVisible, setNewPassVisible] = useState(false);

  const inputHandler = (event) => {
    const { name, value } = event.target;
    setInputData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const toggleNewPassVisibility = () => {
    setNewPassVisible(!newPassVisible);
  };

  const validateForm = () => {
    const error = {};
    const { new_pass } = inputData;
    if (!new_pass.trim()) {
      error.new_pass = "Please enter password.";
    } else if (new_pass.length < 8) {
      error.new_pass = "Password length must be at least 8 characters.";
    }

    setInputError(error);
    return Object.keys(error).length === 0;
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    const isFormValid = validateForm();

    if (isFormValid) {
      try {
        let res = await fetch(POST_DELETE_API, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            password: inputData.confirm_pass,
          }),
        });
        let resJson = await res.json();
        // console.log("resjson", resJson);
        const msg = resJson.message;
        if (msg === "Password has been reset successfully") {
          setShowSuccessfullReset(true);
        }
        // console.log("msg", msg);
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <div className="container resetPassMain">
      <div className="card resetPassCard">
        <div className="card-body p-0">
          <div className="text-center">
            <img src={logo} alt="logo"/></div>

          {showSuccessfullReset ? (
            <div className="mt-5 pt-3">
              <Lottie
                options={{
                  loop: false,
                  autoplay: true,
                  animationData: resetSuccessful,
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={150}
                width={150}
              />
              <p class="successfullMSg mb-2 mt-4">Password Reset Successful</p>
              <p className="loginToMsg">Log In to PHN E learn Web Portal</p>
            </div>
          ) : (
            <>
              {" "}
              {/* <p className="resetPass-title mt-5">Reset Password</p> */}
              <div className="mt-5">
                <form onSubmit={submitHandler}>
                  <div className="pt-5">
                    <label className="resetPass-label_text mb-1">
                      Enter Password
                    </label>

                    <div class="input-group mb-1">
                      <input
                        type={newPassVisible ? "text" : "password"}
                        class="form-control resetPassInput"
                        className="form-control resetPassInput"
                        onChange={inputHandler}
                        value={inputData.new_pass}
                        name="new_pass"
                        aria-label="Recipient's username"
                        aria-describedby="button-addon2"
                      />
                      <button
                        class="btn showPassBtn"
                        type="button"
                        id="button-addon2"
                      >
                        <img
                          src={newPassVisible ? showIcon : hideIcon}
                          alt="eye-icon"
                          className="eye_icon_reset_pass"
                          onClick={toggleNewPassVisibility}
                        />
                      </button>
                    </div>
                    <span className="error-msg">{inputError.new_pass}</span>
                  </div>

                  <input
                    type="submit"
                    value="Submit"
                    className="btn loginBtn w-100 mt-5"
                  />
                </form>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeleteTeacher;
